var map = {
	"./balaji.webp": 29227,
	"./karthikeyan.webp": 71635,
	"./krishnaraja.webp": 27790,
	"./ksampathkumar.webp": 41225,
	"./manoj.webp": 89673,
	"./navaneethan.webp": 8619,
	"./pradeep.webp": 60139,
	"./prasath.webp": 46253,
	"./rampradheep.webp": 19473,
	"./raviprakash.webp": 19906,
	"./sampathkumar.webp": 688,
	"./venkatachalam.webp": 82410,
	"./vishnuvardhan.webp": 64015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51640;